import { createFileRoute } from "@tanstack/react-router";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { LangProvider } from "../contexts/LangContext";
import { VerifyEmailPage } from "../pages/VerifyEmailPage";

export const Route = createFileRoute("/verify-email")({
  head: () => ({
    meta: [{ title: "Emailni tasdiqlash — Lotin.uz" }],
    htmlProps: { lang: "uz-Latn" },
  }),
  component: VerifyEmail,
});

function VerifyEmail() {
  const { i18n } = useTranslation();
  useEffect(() => {
    document.documentElement.lang = "uz-Latn";
    if (i18n?.changeLanguage) i18n.changeLanguage("default");
  }, [i18n]);
  return (
    <LangProvider lang={"uz-Latn"}>
      <VerifyEmailPage />
    </LangProvider>
  );
}
